import { AuthPageContentWrapper } from 'components/AuthPageContentWrapper';
import { OffsetElementType } from 'components/AuthPageContentWrapper/AuthPageContextWrapper.types';
import { TabNavigation } from 'components/TabNavigation';
import { usePathname } from 'hooks/usePathname';
import CustomFieldsSettingsPage from 'pages/Settings/pages/CustomFields/CustomFieldsSettingsPage';
import { SeniorityRankingPage } from 'pages/Settings/pages/Organization/SeniorityRankingPage';
import { Fragment, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import {
  isCustomFieldsFeatureEnabledSelector,
  isOrganizationMultiLocationTieringEnabledSelector,
} from 'store/selectors/featureFlagSelectors';
import { GeneralSettingsPage } from './GeneralSettingsPage/GeneralSettingsPage';
const offsetElements: OffsetElementType[] = ['DesktopPageHeaderHeight', 'TabNavigationHeight'];

export const OrganizationSettingsPage = () => {
  const activeTab = usePathname();
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  const isOrganizationMultiLocationTieringEnabled = useSelector(
    isOrganizationMultiLocationTieringEnabledSelector,
  );
  const isCustomFieldsFeatureEnabled = useSelector(isCustomFieldsFeatureEnabledSelector);

  const tabs = useMemo(() => {
    const settingsOptions = [
      {
        label: t('settings:GENERAL_SETTINGS'),
        path: '/settings/organization/general-settings',
        activePaths: ['/settings/organization/general-settings'],
      },
    ];

    if (isOrganizationMultiLocationTieringEnabled) {
      settingsOptions.push({
        label: t('settings:SENIORITY_RANKING'),
        path: '/settings/organization/seniority-ranking',
        activePaths: ['/settings/organization/seniority-ranking'],
      });
    }

    if (isCustomFieldsFeatureEnabled) {
      settingsOptions.push({
        label: t('common:CUSTOM_FIELDS'),
        path: '/settings/organization/custom-fields',
        activePaths: ['/settings/organization/custom-fields'],
      });
    }
    return settingsOptions;
  }, [isCustomFieldsFeatureEnabled, isOrganizationMultiLocationTieringEnabled, t]);
  const isGeneralSettingsTabSelected = activeTab.startsWith(
    '/settings/organization/general-settings',
  );
  const isSeniorityRankingTabSelected = activeTab.startsWith(
    '/settings/organization/seniority-ranking',
  );

  const isCustomFieldsTabSelected = activeTab.startsWith('/settings/organization/custom-fields');

  return (
    <Fragment>
      <TabNavigation activeTab={activeTab} tabs={tabs} />
      <AuthPageContentWrapper offsetElements={offsetElements}>
        {isGeneralSettingsTabSelected && (
          <Switch>
            <Route path={`${path}/general-settings`} component={GeneralSettingsPage} />
            <Route path={`${path}/general-settings/edit`} component={GeneralSettingsPage} />
          </Switch>
        )}
        {isOrganizationMultiLocationTieringEnabled && isSeniorityRankingTabSelected && (
          <Switch>
            <Route path={`${path}/seniority-ranking`} component={SeniorityRankingPage} />
          </Switch>
        )}
        {isCustomFieldsFeatureEnabled && isCustomFieldsTabSelected && (
          <Switch>
            <Route path={`${path}/custom-fields`} component={CustomFieldsSettingsPage} />
          </Switch>
        )}
      </AuthPageContentWrapper>
    </Fragment>
  );
};
